import type { IconData } from '@stacksjs/iconify-core'

export const doorSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M41.922 7.416c.284 3.002.578 8.145.578 16.584s-.294 13.582-.578 16.584c-.277 2.925-2.486 5.117-5.396 5.406c-2.578.256-6.62.51-12.526.51s-9.948-.254-12.526-.51c-2.91-.29-5.119-2.481-5.396-5.406C5.794 37.582 5.5 32.439 5.5 24s.294-13.582.578-16.584C6.355 4.491 8.564 2.3 11.474 2.01c2.578-.256 6.62-.51 12.526-.51s9.948.254 12.526.51c2.91.29 5.119 2.481 5.396 5.406M29 21a3 3 0 1 0 0 6h4a3 3 0 1 0 0-6z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default doorSolid
